// extracted by mini-css-extract-plugin
export default {"errorBody":"Error_errorBody__EJ3xf","error":"Error_error__9uczQ"};